import React, { Component } from 'react';
import classNames from 'classnames';

import { carsStore } from '../../../../stores';

import { DtcIcon, WarningIcon, BatteryIcon, SwapIcon, ParkedIcon, ArrowCarIcon } from '../../../../common/icons';

import './InfoBubble.css';

export default class InfoBubble extends Component {
  hasAlarms = () => {
    return carsStore.withAlarmsFilterFn(this.props.car);
  };

  hasDtcs = () => {
    return carsStore.withDtcsFilterFn(this.props.car);
  };

  hasBatteryDown = () => {
    return carsStore.withBatteryDownFilterFn(this.props.car);
  };

  render() {
    const { translationsStore, car, address } = this.props;
    let { eta } = this.props;
    if (eta && eta.hasOwnProperty('time') && eta.hasOwnProperty('distance')) {
      const distanceInKm = Number.parseFloat(eta.distance / 1000);
      eta = {
        ...eta,
        time: Math.round(Number(eta.time) / 60),
        distance:
          distanceInKm > 100
            ? distanceInKm.toFixed(0)
            : distanceInKm < 10
            ? distanceInKm.toFixed(2)
            : distanceInKm.toFixed(1)
      };
    }
    const cls = classNames({
      InfoBubble: true,
      withETA: !!this.props.eta
    });
    return (
      <div className={cls} id={`bubble-${car.id}`}>
        <div className="header">
          <div>{car.makeModel}</div>
          <div className="issues">
            {this.hasBatteryDown() && <BatteryIcon style={{ color: 'var(--battery-warning-color)', width: '24px' }} />}
            {this.hasAlarms() && <WarningIcon style={{ color: 'var(--alarm-color)', width: '18px' }} />}
            {this.hasDtcs() && <DtcIcon style={{ color: 'var(--red-dtc-color)', width: '24px' }} />}
          </div>
        </div>
        {!!eta && eta.hasOwnProperty('time') && eta.hasOwnProperty('distance') && (
          <div className="contentEta" id={`eta-${car.id}`}>
            <div>
              <div className="etaAbbreviation">{translationsStore.translate('map.bubble.eta.abbreviation')}</div>
            </div>
            <div>
              <div>
                <div className="etaLabel">{translationsStore.translate('map.bubble.eta.labelTime')}</div>
                <div className="etaValue etaValueTime">{eta.time} min</div>
              </div>
              <div>
                <div className="etaLabel">{translationsStore.translate('map.bubble.eta.labelDistance')}</div>
                <div className="etaValue etaValueDistance">{eta.distance} km</div>
              </div>
            </div>
          </div>
        )}
        <div className="content">
          <div id={`address-${car.id}`}>{address}</div>
          <div>
            {car.ignitionState === 'ignition_on' ? (
              <SwapIcon style={{ color: 'var(--secondary-color)', marginTop: '2px' }} />
            ) : (
              <ParkedIcon style={{ color: 'var(--lock-off)', marginTop: '2px' }} />
            )}
          </div>
        </div>
        {!!eta ? (
          <div className="buttonsContainer" style={{ display: 'flex' }}>
            <div className="button" data-replace-render={JSON.stringify({ fn: 'goToCarView', args: [car.id] })}>
              {translationsStore.translate('map.bubble.eta.buttons.gotofocus')}
            </div>
            <div className="button disabled">
              {translationsStore.translate('map.bubble.eta.buttons.assigntask')}
            </div>
          </div>
        ) : (
          <div className="button" data-replace-render={JSON.stringify({ fn: 'goToCarView', args: [car.id] })}>
            {translationsStore.translate('map.bubble.button.gotofocus')} <ArrowCarIcon />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/InfoBubble/InfoBubble.js